import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import WaiterData from "../../data/WaiterData";
import WaiterDialog from "../../components/settings/WaiterDialog";
import QuestionDialog from "../../components/extras/QuestionDialog";
import CheckPermission from "../../components/extras/CheckPermission";
import localDB from "../../data/localDB";
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {waiterDialog} from "../../actions/WaiterDialogActions";

class Waiters extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Mesero', 'Teléfono', 'Estado', 'Acciones'],
                name: 'Mesero',
                title: 'Meseros',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'waiters',
                values: ['id', 'full_name', 'phone', 'active'],
                boolean_fields: ['active'],
                id: 'table_waiters'
            },
        };
        this.delete = this.delete.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.waiter_select && nextProps.waiter_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.waiter_select);
        }
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.waiterDialog({open:true, waiter:{id:null, full_name:''}});
        }else if(response.event === 'edit'){
            this.props.waiterDialog({open:true, waiter:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }else if(response.event === 'stock'){
            this.props.openModalIngredientStock({is_open:true, data:response.data})
        }
    };

    async delete(id) {
        WaiterData.delete(id, (res) => {
            if (res.delete) {
                this.props.dynamicTableDelete(id);
                this.props.showToast({message: 'Mesero Borrado!', type: 'success'});
                localDB.remove('waiters');
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Meseros | Configuraciones - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Meseros</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <WaiterDialog />
                <QuestionDialog ref="deleteDialog" message="Borrar este mesero" callbackConfirm={this.delete}/>
                <CheckPermission access='waiters_view' />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        waiter_select: state.get('waiter_select'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        waiterDialog(data){
            dispatch(waiterDialog(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Waiters)


// WEBPACK FOOTER //
// ./src/containers/settings/Waiters.js